import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import { IMAGES } from "../data/content";

export default function CTASection() {
  return (
    <section data-testid="cta-section" className="relative overflow-hidden py-28 md:py-36">
      <div className="absolute inset-0">
        <img src={IMAGES.ctaBg} alt="" className="h-full w-full object-cover" />
        <div className="absolute inset-0 bg-black/70" />
        <div className="absolute inset-0 bg-gradient-to-b from-[#050505] via-transparent to-[#050505]" />
      </div>
      <div className="container-x relative z-10 text-center">
        <motion.h2
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
          className="mx-auto max-w-4xl font-playfair text-3xl font-bold leading-tight tracking-tight sm:text-5xl lg:text-6xl"
        >
          Let's create something
          <span className="gold-gradient-text"> unforgettable.</span>
        </motion.h2>
        <motion.p
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8, delay: 0.1 }}
          className="mx-auto mt-6 max-w-xl text-base font-light text-neutral-300"
        >
          Whether it's a feature film, a concert, or an immersive experience —
          tell us your vision and we'll bring it to a global audience.
        </motion.p>
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8, delay: 0.2 }}
          className="mt-10"
        >
          <Link
            to="/contact"
            data-testid="cta-start-project"
            className="group inline-flex items-center gap-2 rounded-full bg-white px-9 py-4 text-sm font-medium text-black transition-all duration-300 hover:bg-gold"
          >
            Start Your Project
            <ArrowRight size={18} className="transition-transform group-hover:translate-x-1" />
          </Link>
        </motion.div>
      </div>
    </section>
  );
}
